export const LOGIN_URL = "admin/login";
export const VERIFY_EMAIL_URL ="admin/verifyEmail"
export const UPDATE_PASSWORD_URL = "admin/forgotPassword"
export const CHANGE_PASSWORD_URL = "admin/resetPassword"
export const FILE_UPLOAD_URL = "common/fileUpload"
export const LIST_OF_PROJECTS_URL = "project/listOfProject"
export const ADD_PROJECT_URL = "project/addProject"
export const EDIT_PROJECT_URL="project/editProject/"
export const DELETE_PROJECT_URL="project/deleteProject/"
export const VIEW_PROJECT_URL="customer/viewProject/"
export const LIST_OF_ENQUIRY_URL = "admin/listOfInquiries"
export const UPDATE_INQUIRY_URL="admin/updateInquiryStatus/"




